// Marker-defined segments (frame ranges) inside src/assets/animations/agent-emotions.json.
// Each segment isolates one named emotion/state from the single combined Lottie file.
export const AGENT_EMOTION_SEGMENTS = {
  greeting: [0, 48],
  happy: [48, 168],
  listening: [168, 192],
  talking: [192, 240],
  thinking: [240, 360],
  sleep: [360, 456],
};
